var map = {
	"./AAVE.png": 252,
	"./ANY.png": 253,
	"./ATOM.png": 254,
	"./AVAX.png": 255,
	"./BAKE.png": 256,
	"./BDO.png": 257,
	"./BDS.png": 258,
	"./BECO.png": 259,
	"./BETH.png": 260,
	"./BHC.png": 261,
	"./BIFI.png": 262,
	"./BLK.png": 263,
	"./BNB.png": 264,
	"./BORING.png": 265,
	"./BTD.png": 266,
	"./BTS.png": 267,
	"./BUNNY.png": 268,
	"./BURGER.png": 269,
	"./BUSD.png": 270,
	"./CTK.png": 271,
	"./DFL.png": 272,
	"./DG.png": 273,
	"./DNFT.png": 274,
	"./DOT.png": 275,
	"./DPET.png": 276,
	"./DRAGON.png": 277,
	"./DRUGS.png": 278,
	"./ETH.png": 279,
	"./FAM.png": 280,
	"./FFF.png": 281,
	"./FTM.png": 282,
	"./HAI.png": 283,
	"./HARD.png": 284,
	"./HBTC.png": 285,
	"./HPS.png": 286,
	"./HT.png": 287,
	"./HUSD.png": 288,
	"./INCH.png": 289,
	"./INJ.png": 290,
	"./JETS.png": 291,
	"./JULD.png": 292,
	"./KABA.png": 293,
	"./KAI.png": 294,
	"./KDX.png": 295,
	"./KEBAB.png": 296,
	"./KPHI.png": 297,
	"./KSC.png": 298,
	"./KUSD.png": 299,
	"./LINK.png": 300,
	"./LPDI.png": 301,
	"./LTD.png": 302,
	"./MARSH.png": 303,
	"./MATIC.png": 304,
	"./MDX.png": 305,
	"./MOWA.png": 306,
	"./MSC.png": 307,
	"./MSS.png": 308,
	"./NUTS.png": 309,
	"./NYA.png": 310,
	"./NYAC.png": 311,
	"./NYAS.png": 312,
	"./O3.png": 313,
	"./PBNB.png": 314,
	"./POLYGON.png": 315,
	"./PUP.png": 316,
	"./PolyDoge.png": 317,
	"./QUICK.png": 318,
	"./RAMP.png": 319,
	"./SBDO.png": 320,
	"./SEN.png": 321,
	"./SFP.png": 322,
	"./SMART.png": 323,
	"./SNX.png": 324,
	"./SOAK.png": 325,
	"./SPIRIT.png": 326,
	"./STEEL.png": 327,
	"./SUSHI.png": 328,
	"./TENFI.png": 329,
	"./THG.png": 330,
	"./TPH.png": 331,
	"./TYPH.png": 332,
	"./UNI.png": 333,
	"./USDC.png": 334,
	"./USDT.png": 335,
	"./WBTC.png": 336,
	"./WOOFY.png": 337,
	"./XTZ.png": 338,
	"./XVS.png": 339,
	"./YELD.png": 340,
	"./YFI.png": 341,
	"./cakeHARD.png": 342,
	"./cakeROOBEE.png": 343,
	"./cakeSTAX.png": 344,
	"./cakeTWT.png": 345,
	"./cakebROOBEE.png": 346,
	"./fUSDT.png": 347,
	"./miMATIC.png": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 944;